module.exports = __webpack_public_path__ + "static/media/twitter_share.e08a99d5.jpg";